
import {
  computed,
  defineComponent,
  onBeforeMount,
  reactive,
  ref,
  watch
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import dayjs from "dayjs";
import { apiErrorCatch, apiRequest, apiSign, bucket } from "@/common/http";
import cigoLayer from "@/components/cigo-layer";
export default defineComponent({
  name: "CigoListManager",
  components: {
    CigoIconFont
  },
  props: {
    refreshLabel: {
      type: String,
      default: "刷新"
    },
    addLabel: {
      type: String,
      default: "新建"
    },
    exportLabel: {
      type: String,
      default: "导出数据"
    },
    rowKey: {
      type: String,
      default: "id"
    },
    emptyText: {
      type: String,
      default: "暂无数据"
    },
    //Tips_Flag 如果出现某个字段不显示考虑这里宽度是否设置小了
    tableScroll: {
      type: Object,
      default: {
        x: 1300,
        y: "max-content"
      }
    },
    bordered: {
      type: Boolean,
      default: false
    },
    dataUrl: {
      type: String,
      default: ""
    },
    statusUrl: {
      type: String,
      default: ""
    },
    viewWinTitle: {
      title: String,
      default: "查看"
    },
    addWinTitle: {
      title: String,
      default: "新增"
    },
    editWinTitle: {
      title: String,
      default: "修改"
    },
    editWinW: {
      type: String,
      default: "600px"
    },
    editWinH: {
      type: String,
      default: "600px"
    },
    columns: {
      type: Array,
      default: [
        {
          title: "编号",
          dataIndex: "id",
          width: 80
        }
      ]
    },
    useDefaultOperation: {
      type: Boolean,
      default: true
    },
    columnsSlots: {
      type: Array,
      default: []
    },
    editComponent: {
      type: Object,
      default: {}
    },
    treeFlag: {
      type: Boolean,
      default: false
    },
    showTopCtrl: {
      type: Boolean,
      default: true
    },
    showPage: {
      type: Boolean,
      default: false
    },
    showBottomCtrl: {
      type: Boolean,
      default: true
    },
    showExportBtn: {
      type: Boolean,
      default: true
    },
    showViewBtn: {
      type: Boolean,
      default: true
    },
    showEditBtn: {
      type: Boolean,
      default: true
    },
    currPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    attachDataForEdit: {
      type: Object,
      default: {}
    },
    paramForSearch: {
      type: Object,
      default: {}
    },
    ctrlBtnsAreaWidth: {
      type: String,
      default: "180px"
    }
  },
  setup(props, ctx) {
    let defaultOperationOption = {
      title: "操作",
      key: "operation",
      fixed: "right",
      width: props.ctrlBtnsAreaWidth,
      slots: {
        customRender: "operation"
      }
    };
    let columnsRef = computed(() => {
      return props.useDefaultOperation
        ? [...props.columns, defaultOperationOption]
        : [...props.columns];
    });

    let page = ref(props.currPage);
    let totalPage = ref(0);
    let dataListRef: any = ref([]);

    onBeforeMount(() => {
      requestList();
    });

    const requestList = () => {
      let params = {};
      Object.assign(params, props.paramForSearch);
      if (props.showPage) {
        let pageInfo = {
          page: page.value,
          pageSize: props.pageSize
        };
        Object.assign(params, pageInfo);
      }
      apiRequest.v1
        .post(props.dataUrl, params, {
          headers: apiSign(params)
        })
        .then((response) => {
          totalPage.value = response.data.data.count;
          dataListRef.value = [...response.data.data.dataList];
        })
        .catch(apiErrorCatch.v1);
    };
    watch(page, (newVal, preVal) => {
      ctx.emit("update:currPage", newVal);
      requestList();
    });

    const ctrlStatus = (record: any, status: number) => {
      let params = {
        id: record.id,
        status: status
      };

      apiRequest.v1
        .post(props.statusUrl, params, {
          headers: apiSign(params)
        })
        .then((response) => {
          // 提示
          cigoLayer.msg(response.data.msg);
          // 处理数据
          if (status != -1) {
            record.status = status;
          } else if (props.treeFlag) {
            let tmpItem: any = reactive({
              id: 0,
              subList: dataListRef.value
            });
            deleteLocal(tmpItem, record, 0);
            if (tmpItem.subList && tmpItem.subList.length) {
              dataListRef.value = [...tmpItem.subList];
            } else {
              dataListRef.value = [];
            }
          } else {
            let tmpList = [...dataListRef.value];
            tmpList.splice(tmpList.indexOf(record), 1);
            dataListRef.value = [...tmpList];
          }
        })
        .catch(apiErrorCatch.v1);
    };

    const deleteLocal = (item: any, record: any, level: number): boolean => {
      if (!item.subList || !item.subList.length) {
        delete item.subList;
        return false;
      }
      let hasFlag = false;
      let hasIndex = -1;
      item.subList.every((item: any, index: number) => {
        // 判断当前项
        if (item.id == record.id) {
          hasFlag = true;
          hasIndex = index;
          return false;
        }
        // 判断子级
        if (deleteLocal(item, record, level + 1)) {
          hasFlag = true;
          return false;
        }
        // 都不存在，继续
        return true;
      });
      if (hasFlag && hasIndex > -1) {
        let tmpSubList = [...item.subList];
        tmpSubList.splice(hasIndex, 1);
        tmpSubList.length
          ? (item.subList = [...tmpSubList])
          : delete item.subList;
      }
      return hasFlag;
    };

    const ctrlView = (record: any) => {
      cigoLayer.component({
        component: props.editComponent,
        width: props.editWinW,
        height: props.editWinH,
        maskClose: true,
        layerData: {
          title: props.viewWinTitle,
          recordCurr: record,
          viewFlag: true,
          dataListRef: dataListRef,
          ...props.attachDataForEdit
        }
      });
    };

    const notify = (flag: string, dataList?: any) => {
      switch (flag) {
        case "refresh":
          dataListRef.value = [...dataList];
          break;
      }
    };

    const ctrlNew = () => {
      cigoLayer.component({
        component: props.editComponent,
        width: props.editWinW,
        height: props.editWinH,
        maskClose: false,
        layerData: {
          title: props.addWinTitle,
          dataListRef: dataListRef,
          ...props.attachDataForEdit
        },
        notify: notify
      });
    };
    const ctrlAddSub = (record: any) => {
      cigoLayer.component({
        component: props.editComponent,
        width: props.editWinW,
        height: props.editWinH,
        maskClose: false,
        layerData: {
          title: props.addWinTitle,
          recordParent: record,
          dataListRef: dataListRef,
          ...props.attachDataForEdit
        },
        notify: notify
      });
    };

    const ctrlEdit = (record: any) => {
      cigoLayer.component({
        component: props.editComponent,
        width: props.editWinW,
        height: props.editWinH,
        maskClose: false,
        layerData: {
          title: props.editWinTitle,
          recordCurr: record,
          dataListRef: dataListRef,
          ...props.attachDataForEdit
        },
        notify: notify
      });
    };

    return {
      columnsRef,
      requestList,
      page,
      totalPage,
      dataListRef,
      dayjs,
      ctrlNew,
      ctrlAddSub,
      ctrlStatus,
      ctrlView,
      ctrlEdit
    };
  }
});
